import '../App.css';
import { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { loadCampaign, patchCampaign } from '../QueryCampaign';
import V2Card from '../V2Card';
import { ProgressSpinner } from 'primereact/progressspinner';

function CampaignSettings({ campaign_id, getCampaign }) {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [campaign, setCampaign] = useState(null);
    const [campaignStatus, setCampaignStatus] = useState(null);
    const [maxSecondsToDisplay, setMaxSecondsToDisplay] = useState(null);
    const [isMuted, setIsMuted] = useState(null);

    // const [startDate, setStartDate] = useState(null);
    // const [endDate, setEndDate] = useState(null);

    const statusValues = [
        { name: 'active' },
        { name: 'deactivated' },
    ];

    function saveSettings() {
        setIsLoading(true);
        patchCampaign(
            campaign_id,
            {
                status: campaignStatus.name,
                creative_max_seconds_to_display: maxSecondsToDisplay,
                creative_is_muted: isMuted,
            }
        ).then(
            (response) => {
                setTimeout(
                    () => {
                        setIsLoading(false);
                        getCampaign();
                        navigate(`/campaign?campaign_id=${campaign_id}`);
                    },
                    1000,
                )
            }
        ).catch(
            (error) => {
                navigate('/');
            }
        )
    }

    useEffect(
        () => {
            loadCampaign(campaign_id).then(
                (response) => {
                    const campaign = response.data;
                    setCampaign(campaign);
                    setCampaignStatus({ name: campaign.status });
                    setMaxSecondsToDisplay(campaign.creative_max_seconds_to_display);
                    setIsMuted(campaign.creative_is_muted);
                }
            )
        },
        [],
    )

    return (
        <V2Card>
            <div
                style={{ marginLeft: '1em' }}
            >
                <div
                    style={{ marginTop: '2em' }}
                >
                    <h4>
                        Status:
                    </h4>
                    <Dropdown
                        value={campaignStatus}
                        onChange={(e) => setCampaignStatus(e.value)}
                        options={statusValues}
                        optionLabel="name"
                        placeholder="select a status"
                        className="w-full md:w-14rem"
                    />
                </div>
                <div
                    style={{ marginTop: '2em' }}
                >
                    <h4>
                        Time to display (seconds):
                    </h4>
                    <div>
                        <InputText
                            value={maxSecondsToDisplay}
                            onChange={(e) => setMaxSecondsToDisplay(e.target.value)}
                            placeholder='time to display in seconds'
                            type='number'
                        />
                    </div>
                </div>
                <div
                    style={{ marginTop: '2em', cursor: 'pointer' }}
                    onClick={() => setIsMuted(!isMuted)}
                >
                    <h4>
                        Sound
                    </h4>
                    <div>
                        <div
                            className="flex align-items-center"
                            style={{ display: 'flex' }}
                        >
                            <Checkbox
                                name="is_muted"
                                value={isMuted}
                                checked={isMuted}
                            />
                            <div className="ml-2" style={{ marginLeft: '0.3em' }}>
                                is muted
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                !isLoading &&
                <Button
                    label='Save'
                    severity='success'
                    size='small'
                    onClick={saveSettings}
                    style={{ marginLeft: '1em', marginTop: '2em' }}
                    outlined
                />
            }
            {
                isLoading &&
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'left',
                        marginLeft: '1em',
                    }}
                >
                    <div style={{ width: 'min-content', marginRight: '1em' }}>
                        <ProgressSpinner
                            style={{ width: '2em' }}
                        />
                    </div>
                    <div>
                        Saving...
                    </div>
                </div>
            }
        </V2Card>
    );
}

export default CampaignSettings;